import type { ReactNode } from "react";

/**
 * Break-glass. On a desktop the page splits into two columns, the photo
 * controls on the left and the shipment details on the right, so the card uses
 * the width instead of running long and narrow. Below desktop width it stacks
 * as one column. The photo column centres vertically against the details, so
 * the camera button doesn't float at the top of an empty column. ui-core has no
 * responsive two-column primitive. The finish control sits in the bottom-right
 * corner of the details column, in space that column already has spare, so it
 * doesn't make the card taller.
 */
export function UploadPhotosColumns({
  photos,
  details,
  finish,
}: {
  photos: ReactNode;
  details: ReactNode;
  finish: ReactNode;
}) {
  return (
    <div className="flex flex-col gap-6 lg:flex-row lg:items-start lg:gap-10">
      <div className="flex min-w-0 flex-1 flex-col gap-6 lg:self-center">
        {photos}
      </div>
      <div className="flex flex-col gap-6 lg:w-80 lg:shrink-0 lg:self-stretch lg:border-l lg:border-border lg:pl-10">
        {details}
        <div className="mt-auto self-end">{finish}</div>
      </div>
    </div>
  );
}
